<template>
  <div class="download_center">
    <div class="banner">
      <img class="banner_img" src="../../assets/img/download_banner_1.png" />
      <div class="banner_text">
        <h4>
          下载中心
        </h4>
        <p>
          <i></i>
          <span>易招聘移动端</span>
        </p>
        <p>
          <i></i>
          <span>随时随地</span>
        </p>
        <p>
          <i></i>
          <span>移动办公</span>
        </p>
        <div class="qrcodes">
          <div><img src="../../assets/img/qr_code.png"/><p>钉钉扫描</p><p>二维码使用</p></div>
          <div><img src="../../assets/img/qr_qw_code.png"/><p>企业微信扫描</p><p>二维码使用</p></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {};
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "7");
  },
  computed: {},
  methods: {}
};
</script>
<style lang="scss">
.download_center {
  .banner {
    height: 920px;
    position: relative;
    .banner_img {
      height: 100%;
    }
    .banner_text {
      position: absolute;
      top: 200px;
      left: 360px;
      h4 {
        font-size: 70px;
        font-weight: 600;
        color: #fff;
      }
      > p {
        i {
          display: inline-block;
          width: 7px;
          height: 7px;
          background: #007bff;
          border-radius: 50%;
          vertical-align: middle;
          margin-right: 5px;
        }

        font-size: 24px;
        font-weight: 400;
        color: #fff;
        margin-top: 18px;
      }
      .qrcodes {
        display: flex;
        gap: 43px;
        font-size: 16px;
        font-family: AlibabaPuHuiTi_2_65_Medium;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
        margin-top: 74px;
        img {
          width: 135px;
          height: 135px;
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/downloadCenter.vue